<template>
  <div>
    <MemberLayout>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header text-white bg-primary">詳細資料</div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  <h3>基本資訊</h3>
                  <p>營業月份：{{ customer.MRESULTS }}</p>
                  <p class="mb-0">組織報表更新時間：{{ customer.CDATE }}</p>
                </li>
                <li class="list-group-item">
                  <h3>會員資訊</h3>
                  <p>會員ID：{{ customer.JPSEQ }}</p>
                  <p>會員姓名： {{ customer.NAME }}</p>
                  <p>定期OK： {{ customer.ACT }}</p>
                  <p>會員別： {{ customer.courseName }}</p>
                  <p>職稱： {{ customer.positionName }}</p>
                  <p>聘階： {{ customer.rankName }}</p>
                  <p>入會日期： {{ customer.REGISTDATE }}</p>
                  <p>推薦人ID： {{ hideId(customer.INTROSEQ) }}</p>
                  <p>推薦人姓名：{{ introName }}</p>
                  <p>安置人ID： {{ hideId(customer.UPLINE) }}</p>
                  <p>首購PV： {{ getNumberWithCommas(customer.INTROPOINT) }}</p>
                  <p>
                    定期PV： {{ getNumberWithCommas(customer.REPEATPOINT) }}
                  </p>
                  <p>加購PV： {{ getNumberWithCommas(customer.ADDPOINT) }}</p>
                  <p>第1層PV數： {{ getNumberWithCommas(customer.LBL1PV) }}</p>
                  <p>第2層PV數： {{ getNumberWithCommas(customer.LBL2PV) }}</p>
                  <p>第3層PV數： {{ getNumberWithCommas(customer.LBL3PV) }}</p>
                  <p>3層內PV數： {{ getNumberWithCommas(customer.L3PVF) }}</p>
                  <p>
                    組職總pv數： {{ getNumberWithCommas(customer.GRPPOINT) }}
                  </p>
                </li>
                <li class="list-group-item">
                  <h3>組織資訊</h3>
                  <p>組職總人數： {{ getNumberWithCommas(customer.GRPCNT) }}</p>
                  <p>A會員人數 {{ getNumberWithCommas(customer.GRPCNT_A) }}</p>
                  <p>B會員人數 {{ getNumberWithCommas(customer.GRPCNT_B) }}</p>
                  <p>C會員人數 {{ getNumberWithCommas(customer.GRPCNT_C) }}</p>
                  <p>
                    直接推薦人數 {{ getNumberWithCommas(customer.AB_TOTAL) }}
                  </p>
                </li>
                <li class="list-group-item">
                  <h3>組織活躍狀態</h3>
                  <p>
                    組織定期OK的人數：
                    {{ getNumberWithCommas(customer.ACTIVEGRPCNT) }}
                  </p>
                  <p>
                    A會員定期OK人數：
                    {{ getNumberWithCommas(customer.ACTIVE_A) }}
                  </p>
                  <p>
                    B會員定期OK人數：
                    {{ getNumberWithCommas(customer.ACTIVE_B) }}
                  </p>
                  <p>
                    直接推薦定期OK人數：
                    {{ getNumberWithCommas(customer.AB_ACTIVE_TOTAL) }}
                  </p>
                </li>
                <li class="list-group-item">
                  <h3>3層內狀態</h3>
                  <p>
                    第1層定期OK數： {{ getNumberWithCommas(customer.LBL1) }}
                  </p>
                  <p>
                    第2層定期OK數： {{ getNumberWithCommas(customer.LBL2) }}
                  </p>
                  <p>
                    第3層定期OK數： {{ getNumberWithCommas(customer.LBL3) }}
                  </p>
                  <p>
                    第1層領導員LD人數：
                    {{ getNumberWithCommas(customer.LBL1LD) }}
                  </p>
                  <p>
                    第1層指導員DR人數：
                    {{ getNumberWithCommas(customer.LBL1DR) }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
import MemberLayout from "../../components/member/MemberLayout";
import { getNumberWithCommas, hideId } from "../../api/fordaysHelpers";
import db from "../../api/db";
export default {
  name: "HierarchyDetailScreen",
  components: {
    MemberLayout,
  },
  data() {
    return {
      searchMonth: "",
      SEQ: "",
      customer: {},
      introName: "",
    };
  },
  methods: {
    getNumberWithCommas(val) {
      return getNumberWithCommas(val);
    },
    hideId(val) {
      return hideId(val);
    },
  },
  mounted() {
    const vm = this;
    if (!window.sessionStorage.getItem("subSearchSEQ")) {
      return;
    }
    const session = JSON.parse(window.sessionStorage.getItem("subSearchSEQ"));
    window.sessionStorage.removeItem("subSearchSEQ");
    vm.searchMonth = session.searchMonth;
    vm.SEQ = session.SEQ;
    fetchData();
    async function fetchData() {
      let doc = await db
        .collection("JC2map_masterOut")
        .doc(`${vm.SEQ}${vm.searchMonth}`)
        .get();
      let customer = doc.data();

      // 取得會員別文件
      let courseDoc = await db
        .collection("jqualificationtypeout")
        .doc(`${customer.COURSE}`)
        .get();
      customer.courseName = "";
      if (courseDoc.exists) {
        customer.courseName = courseDoc.data().NAME;
      }

      // 設定職稱
      customer.positionName = "";
      if (customer.POSITION == 0) {
        customer.positionName = "無";
      } else if (customer.POSITION == 1) {
        customer.positionName = "DR";
      } else {
        customer.positionName = "LD";
      }

      // 取得聘階文件
      customer.rankName = "";
      let rankDoc = await db
        .collection("jranktypeout")
        .doc(`${customer.RANK}`)
        .get();

      if (rankDoc.exists) {
        customer.rankName = rankDoc.data().NAME;
      }
      // 取得推薦人ID
      const introSEQ = customer["INTROSEQ"];
      // 取得推薦人文件
      let introDoc = await db.doc(`jcustomerout/${introSEQ}`).get();
      let introName = "";
      // 如果文件存在
      if (introDoc.exists) {
        introName = introDoc.data().NAME;
      }
      vm.customer = customer;
      vm.introName = introName;
    }
  },
};
</script>
<style scoped>
.list-group-item p:last-child {
  margin-bottom: 0px;
}
</style>